export default function($log, $q, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.setSelect = () => {
    if (typeof vm.inviteOnly === 'undefined') vm.selected = 'firm';
    else if (vm.inviteOnly) vm.selected = 'invite';
    else if (vm.firmOnly) vm.selected = 'firm';
    else vm.selected = 'open';
    if (!vm.registrationAccess) vm.registrationAccess = 'admin';
    vm.setEventAccess();
  };

  vm.setEventAccess = () => {
    if (vm.selected === 'firm') {
      vm.inviteOnly = false;
      vm.firmOnly = true;
      return;
    }
    if (vm.selected === 'invite') {
      vm.inviteOnly = true;
      vm.firmOnly = false;
      return;
    }
    if (vm.selected === 'open') {
      vm.inviteOnly = false;
      vm.firmOnly = false;
      return;
    }
  };

  function activate() {
    $log.log('Course Access Component Activated');
    vm.companyId = company_id;
    vm.setSelect();
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/courseAccessEditor/controller.js